import { render, staticRenderFns } from "./EntityRelationships.vue?vue&type=template&id=3d446560"
import script from "./EntityRelationships.vue?vue&type=script&lang=js"
export * from "./EntityRelationships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports